import { isEmpty } from "lodash";

export default function formatContactName(contact) {
  const { first_name, last_name } = contact;
  const firstName = first_name ? first_name : "";
  const lastName = last_name ? last_name : "";
  const space = !isEmpty(firstName) && !isEmpty(lastName) ? " " : "";
  return `${firstName}${space}${lastName}`;
}
